import './Variants.css'
import React from 'react'
import { map, orderBy } from 'lodash'
import { keygen, db } from '../../services/firebase'
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Button from 'elements/CustomButton/CustomButton.jsx'
import Modal from 'components/Modal/Modal.jsx'
import VariantForm from '../../forms/VariantForm.jsx'
import ItemForm from '../../forms/ItemForm.jsx'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SweetAlert from 'react-bootstrap-sweetalert'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'

export default class Variants extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            alert: null,
            variantModal: false,
            targetVariant: null,
            itemModal: false,
            targetItem: null,
            fabricLines: [],
            fetchingFabricLines: false
        }

        this.product = props.product
        this.notify = props.notify
        this.resetForm = props.resetForm
        this.addVariant = props.addVariant
        this.removeVariant = props.removeVariant
        this.addVariantItem = props.addVariantItem
        this.removeVariantItem = props.removeVariantItem
    }

    componentDidMount() {
        this._fetchFabricLines()
    }

    render() {
        const { alert } = this.state
        const { product } = this.props
        return (
            <div className='variants'>
                {alert}
                {this.variantModal()}
                {this.itemModal()}
                <Row>
                    <div className='variants_header'>
                        <span className='variants_header_title'>Variantes</span>
                        <Button
                            bsStyle='default'
                            wd
                            className='variants_header_button'
                            onClick={() => {
                                this.props.resetForm('VariantForm')
                                this.setState({ variantModal: true, targetVariant: null })
                            }}
                        >
                            Adicionar
                        </Button>
                    </div>
                    <Col md={12}>
                        {map(product.variants, variant => {
                            return (
                                <div className='variant_block' key={variant.id}>
                                    <div className='variant'>
                                        <p className='variant_name'>{variant.name}</p>
                                        <div className='variant_actions'>
                                            <div className='variant_action'>
                                                <OverlayTrigger
                                                    placement='top'
                                                    overlay={(<Tooltip id={`add_${variant.id}`}>Adicionar Item</Tooltip>)}
                                                >
                                                    <FontAwesomeIcon
                                                        icon='plus'
                                                        onClick={() => {
                                                            this.props.resetForm('ItemForm')
                                                            this.setState({ targetVariant: variant, itemModal: true, targetItem: null })
                                                        }}
                                                    />
                                                </OverlayTrigger>
                                            </div>
                                            <div className='variant_action'>
                                                <OverlayTrigger
                                                    placement='top'
                                                    overlay={(<Tooltip id={`edit_${variant.id}`}>Editar</Tooltip>)}
                                                >
                                                    <FontAwesomeIcon
                                                        icon='edit'
                                                        onClick={() => this.setState({ targetVariant: variant, variantModal: true })}
                                                    />
                                                </OverlayTrigger>
                                            </div>
                                            <div className='variant_action'>
                                                <OverlayTrigger
                                                    placement='top'
                                                    overlay={(<Tooltip id={`remove_${variant.id}`}>Remover</Tooltip>)}
                                                >
                                                    <FontAwesomeIcon
                                                        icon='trash'
                                                        onClick={() => this.removeVariantAlert(variant.id)}
                                                    />
                                                </OverlayTrigger>
                                            </div>
                                        </div>
                                    </div>

                                    {variant.items && map(variant.items, item => (
                                        <div className='variant_item' key={item.id}>
                                            <div className='variant_item_header'>
                                                <span className='item_name'>{item.name} - {item.description}</span>
                                                <div className='item_actions'>
                                                    <div className='item_action'>
                                                        <OverlayTrigger
                                                            placement='top'
                                                            overlay={(<Tooltip id={`edit_${item.id}`}>Editar</Tooltip>)}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon='edit'
                                                                onClick={() => this.setState({
                                                                    targetVariant: variant,
                                                                    targetItem: item,
                                                                    itemModal: true
                                                                })}
                                                            />
                                                        </OverlayTrigger>
                                                    </div>
                                                    <div className='item_action'>
                                                        <OverlayTrigger
                                                            placement='top'
                                                            overlay={(<Tooltip id={`remove_${item.id}`}>Remover</Tooltip>)}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon='trash'
                                                                onClick={() => this.removeItemAlert(variant.id, item.id)}
                                                            />
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                            </div>
                                            {item.composition && item.composition.length >= 1 && (
                                                <div>
                                                    <div className='variant_item_spacer' />
                                                    <div className='variant_item_compositions'>
                                                        <span className='composition_header'>Composê: </span>
                                                        {map(item.composition, (comp, index) => (
                                                            <div className='variant_item_comp' key={index}>
                                                                {comp.description}: {comp.percentage}%
                                                        </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}

                                            {item.accessories && item.accessories.length >= 1 && (
                                                <div>
                                                    <div className='variant_item_spacer' />
                                                    <div className='variant_item_accessories'>
                                                        <span className='accessories_header'>Acessórios: </span>
                                                        {map(item.accessories, (accessory, index) => (
                                                            <div className='variant_item_accessory' key={index}>
                                                                {accessory.description}: R$ {accessory.price}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                            {item.fabricLines && item.fabricLines.length >= 1 && (
                                                <div>
                                                    <div className='variant_item_spacer' />
                                                    <div className='variant_item_product_lines'>
                                                        {map(orderBy(item.fabricLines, ['name']), (fx, index) => {
                                                            if (fx.value !== '') {
                                                                return (
                                                                    <div className='variant_item_fx' key={index}>
                                                                        <span className='fx_name'>{fx.name}</span>
                                                                        <span className='fx_value'>{fx.value}</span>
                                                                    </div>
                                                                )
                                                            }
                                                        })}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )
                        })}
                    </Col>
                </Row>
            </div>
        )
    }

    variantModal = () => {
        const { variantModal, targetVariant } = this.state
        return (
            <Modal
                title={targetVariant ? 'Atualizar variante' : 'Adicionar variante'}
                isOpen={variantModal}
                content={
                    <VariantForm
                        initialValues={targetVariant}
                        onSubmit={values => {
                            targetVariant
                                ? this._updateVariant(values)
                                : this._addVariant(values)
                        }}
                        handleCancel={() => this.setState({ variantModal: false })}
                    />
                }
            />
        )
    }

    itemModal = () => {
        const { itemModal } = this.state
        return (
            <Modal
                overflowY
                title='Adicionar Item'
                isOpen={itemModal}
                content={
                    <div>{this._handleItemModalContent()}</div>
                }
            />
        )
    }

    _handleItemModalContent() {
        const { fetchingFabricLines, fabricLines, targetItem } = this.state
        if (fetchingFabricLines) {
            return (
                <div>
                    <p>Buscando faixas de tecido, aguarde</p>
                </div>
            )
        } else {
            return (
                <ItemForm
                    initialValues={
                        targetItem
                            ? this._prepareInitialValues(fabricLines, targetItem)
                            : this._prepareInitialValues(fabricLines)
                    }
                    onSubmit={values => this._addItem(values)}
                    handleCancel={() => this.setState({ itemModal: false })}
                />
            )
        }
    }

    _prepareInitialValues = (fabricLines, anotherValues) => {
        const initialValues = { ...anotherValues, fabricLines: [] }
        map(fabricLines, item => (initialValues.fabricLines.push(item)))
        initialValues.fabricLines = orderBy(initialValues.fabricLines, ['name', 'asc'])

        if (anotherValues && anotherValues.fabricLines && anotherValues.fabricLines.length >= 1) {
            //Merges fabric lines to raw initialValues data object
            map(anotherValues.fabricLines, fabricLine => initialValues[fabricLine.fx] = fabricLine.value)
        }

        return initialValues
    }


    _addVariant(data) {
        let id = keygen()
        this.props.addVariant({ ...data, id })
        this.setState({ variantModal: false })
    }

    _updateVariant(data) {
        this.props.addVariant(data) //overwrites the selected variant using the same method. Easy.
        this.setState({ variantModal: false })
    }

    _removeVariant(id) {
        this.props.removeVariant(id)
        this.hideAlert()
    }

    _addItem(data) {
        const { targetVariant, targetItem } = this.state
        const { fabricLines, name, description } = data

        let output = {
            name,
            description,
            fabricLines: [],
            composition: data.composition ? this._assignRandomIDs(data.composition) : null,
            accessories: data.accessories ? this._assignRandomIDs(data.accessories) : null
        }

        //Indexing FXs values with their current names
        const dataKeys = Object.keys(data)
        map(fabricLines, line => {
            let dataKeyIndex = dataKeys.indexOf(line.id)
            dataKeyIndex > -1
                && (output.fabricLines.push({
                    value: data[line.id],
                    name: line.name,
                    fx: dataKeys[dataKeyIndex]
                }))
        })

        let key = targetItem ? targetItem.id : keygen()

        //Same as before. Adding and updating with the a single method.
        this.props.addVariantItem({ variantID: targetVariant.id, newItem: { ...output, id: key } })
        this.setState({ itemModal: false })
    }

    //assign a random generated ID to each item in array
    _assignRandomIDs(data) {
        const output = []
        map(data, item => output.push({ ...item, id: keygen() }))
        return output
    }

    _removeItem(variantID, itemID) {
        this.props.removeVariantItem({ variantID, itemID })
        this.hideAlert()
    }

    _fetchFabricLines() {
        const fabricLines = []
        this.setState({ fetchingFabricLines: true })
        db.collection('fabric_lines').get()
            .then(snapshot => {
                if (!snapshot.empty) {
                    snapshot.forEach(s => fabricLines.push({ ...s.data(), id: s.id }))
                    this.setState({ fabricLines: orderBy(fabricLines, ['name'],['asc']), fetchingFabricLines: false })
                } else {
                    this.setState({ fetchingFabricLines: false })
                }
            })
            .catch(e => {
                this.setState({ fetchingFabricLines: false })
                this.props.notify('Erro ao buscar as linhas de tecido.', 'error')
            })
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    removeVariantAlert = variantID => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeVariant(variantID)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                >
                    A variante selecionada será removida, juntamente com todos seus itens.
                 </SweetAlert>
            )
        });
    }

    removeItemAlert = (variantID, itemID) => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._removeItem(variantID, itemID)}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                />
            )
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/Variants/Variants.jsx